/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
import { filter, isUndefined } from 'lodash';
import { sentenceCase } from 'change-case';
import React, { useState } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
// material
import {
    Stack,
    Container,
    Typography,
    Paper,
    Grid,
    Box,
    TextField,
    LinearProgress,
    ToggleButtonGroup,
    styled,
    ToggleButton,
    Autocomplete,
    AccordionSummary,
    AccordionDetails,
    Accordion,
} from '@mui/material';
// components
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, Timestamp, updateDoc } from 'firebase/firestore';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../../firebase.config';
import Page from '../../../components/Page';
import Label from '../../../components/Label';
import Scrollbar from '../../../components/Scrollbar';
import Iconify from '../../../components/Iconify';
import CustomButton from '../../../components/CustomButton';
import CustomSnack from '../../../components/customSnack';
import NumberTextField from '../../../components/NumberTextField';
import { useSnackbar } from '../../../context/snackbarContext';
import CustomModal from '../../../components/customModal/customModal';


// ----------------------------------------------------------------------
// Toogle Group Button
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        margin: 0.5,
        width: 60,
        height: 30,
        border: 0,
        // background: 'black',
        '&.Mui-disabled': {
            border: 0,
        },
        '&.Mui-selected': {
            border: 0,
            background: '#5E17EB',
            color: 'white',
            '&:hover': {
                backgroundColor: '#5E17EB',

            },
        },
        '&:not(:first-of-type)': {
            // background: 'red',
            borderRadius: '7px',
        },
        '&:first-of-type': {
            // background: 'black',
            borderRadius: '7px',
        },
    },
}));
//-----------------------------------------------------------------------
// ----------------------------------------------------------------------
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

// for modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    bgcolor: 'white',
    border: '1px solid white',
    borderRadius: '7px',
    boxShadow: 0,
    p: 3,
};

export default function AddAffiliate() {
    const { eventID } = useParams();
    const { affId } = useParams();
    const navigate = useNavigate();
    const showSnackBar = useSnackbar()
    // loading
    const [loading, setLoading] = React.useState(false);



    //  snack bar
    const [openSnack, setOpenSnack] = React.useState(false);
    const [msg, setMsg] = React.useState({ content: '', color: '' });
    const handleCloseSnack = () => {
        setOpenSnack(false);
    };

    // navigate(-1, { replace: true });



    // Modal deleted
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);

    // variables
    const [name, setName] = React.useState('');
    const [nameError, setNameError] = React.useState({});
    const [emailError, setEmailError] = React.useState({});
    const [email, setEmail] = React.useState('');
    const [affData, setAffData] = React.useState({});
    const [commission, setCommission] = React.useState(false);
    const [commissionType, setCommissionType] = React.useState(1);
    const [commissionValue, setCommissionValue] = React.useState(0);
    const [commissionError, setCommissionError] = React.useState({});
    const [codePromo, setCodePromo] = React.useState(false);
    const [promoCode, setPromoCode] = React.useState('');
    const [promoType, setPromoType] = React.useState(0);
    const [promoValue, setPromoValue] = React.useState(0);
    const [codePromoError, setCodePromoError] = React.useState({});
    const [selectedDiscount, setSelectedDiscount] = React.useState();
    const [discounts, setDiscounts] = React.useState([]);

    const handleCommission = () => {
        setCommission(!commission)
    };
    const handleName = (e) => {
        setName(e.target.value)
    };
    const handleEmail = (e) => {
        setEmail(e.target.value)
    };
    const handleCommissionValue = (e) => {
        console.log(e.target)
        console.log(e)
        setCommissionValue(e)
    };
    const handlePromo = () => {
        setCodePromo(!codePromo)
    };
    const handlePromoCode = (e) => {
        setPromoCode(e)
    };
    const handlePromoValue = (e) => {
        setPromoCode(e)
    };

    const checkValue = () => {
        let validate = true
        console.log(name)
        if (name === '') {
            setNameError({ error: true, msg: 'ce champ est requis' })
            validate = false
        } else {
            setNameError({})
        }
        if (email === '') {
            setEmailError({ error: true, msg: 'ce champ est requis' })
            validate = false
        } else {
            setEmailError({})
        }
        if (commission && commissionValue === 0) {
            setCommissionError({ error: true, msg: 'ce champ est requis' })
            validate = false
        } else {
            setCommissionError({})
        }
        if (codePromo && isUndefined(selectedDiscount)) {
            setCodePromoError({ error: true, msg: 'ce champ est requis' })
            validate = false
        } else {
            setCodePromoError({})
        }
        return validate
    }

    // create affiliation
    const createAffiliation = async () => {
        try {
            // Appel à la fonction Cloud pour créer l'affiliation
            setLoading(true)
            const validate = checkValue()
            if (!validate) {
                setLoading(false)
                showSnackBar('Erreur lors de la création de l’affiliation', true)
                return
            }
            const createAffiliationFunction = httpsCallable(functions, 'addAffiliate');

            const response = await createAffiliationFunction({
                eventID,
                partnerData: { name, email },
                commissionData: { type: commissionType, value: commissionValue },
                promoId: selectedDiscount?.id
            });


            if (response.data.message === 'ok') {
                console.log('Affiliation créée avec succès:', response.data);
                showSnackBar('Affiliation créée avec succès', false)
                navigate(-1)
            } else {
                console.log('Erreur lors de la création de l’affiliation:', response.data);
                showSnackBar('Erreur lors de la création de l’affiliation', true)
            }

        } catch (error) {
            showSnackBar('Erreur lors de la création de l’affiliation', true)
            console.error('Erreur lors de la création de l’affiliation:', error);
        }
        setLoading(false)
    };

    // create affiliation
    const updateAffiliation = async () => {
        try {
            // Appel à la fonction Cloud pour créer l'affiliation
            console.log(eventID)
            setLoading(true)
            const validate = checkValue()
            if (!validate) {
                setLoading(false)
                showSnackBar('Erreur lors de la création de l’affiliation', false)
                return
            }
            const response = await fetch('https://us-central1-event-86cbf.cloudfunctions.net/updateAffiliation', {
                method: 'POST',
                body: JSON.stringify({
                    eventId: eventID,
                    aff: affId,
                    partnerData: { name, email },
                    commissionData: { type: commissionType, value: commissionValue },
                    promoId: selectedDiscount?.id,
                    oldPromoId: affData?.promoId
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                showSnackBar('Affiliation mis a jour  avec succès', false)
                navigate(-1)
            } else {
                console.log('Erreur lors de la mise a jour de l’affiliation:', response);
                showSnackBar('Erreur lors de la mise a jour de l’affiliation', false)
            }

        } catch (error) {
            console.log('Erreur lors de la mise a jour de l’affiliation:', error);
            showSnackBar('Erreur lors de la mise a jour de l’affiliation', false)
        }
        setLoading(false)
    };

    const handleEventSelect = (discount) => {
        setSelectedDiscount(discount)
        // Faire quelque chose avec l'événement sélectionné (ex: le sauvegarder dans la campagne)
    };

    React.useEffect(() => {
        (async () => {
            setDiscounts([]);

            try {
                setLoading(true);
                const q = query(collection(db, `evenement/${eventID}/codePromo`));
                const snapshot = await getDocs(q);
                const tmp = []
                snapshot.forEach((d) => {
                    // ticketList((tickets) => [...tickets, d]);
                    tmp.push(d)
                });
                setDiscounts(tmp);
                setLoading(false);
            } catch (error) {
                console.log('error');
                setLoading(false);
            }
        })();
    }, [eventID]);

    React.useEffect(() => {
        (async () => {
            // ticketList([]);
            setLoading(true);
            try {
                //
                const affInfo = await getDoc(doc(db, `evenement/${eventID}/affiliations`, affId))
                if (affInfo.exists()) {
                    setAffData(affInfo.data())
                    setName(affInfo.data().name)
                    setEmail(affInfo.data().email)
                    if (affInfo.data().commission !== null) {
                        setCommission(true)
                        setCommissionValue(affInfo.data().commission.value)
                        setCommissionType(affInfo.data().commission.type)
                    }
                    if (affInfo.data().promoId !== null) {
                        const codeInfo = await getDoc(doc(db, `evenement/${eventID}/codePromo`, affInfo.data().promoId))
                        if (codeInfo.exists()) {
                            setCodePromo(true)
                            setSelectedDiscount(codeInfo)
                        }

                    }
                }
                setLoading(false);
            } catch (error) {
                console.log('error');
                console.log(error);
                setLoading(false);
            }
        })();
    }, [affId, eventID]);


    const [openModal, setOpenModal] = useState(false);

    React.useEffect(() => {
        const hideTips = localStorage.getItem('hideInfluenceurTips');
        if (affId) return;

        if (!hideTips) {
            setOpenModal(true);
        }
    }, [affId]);

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleNeverShowAgain = () => {
        localStorage.setItem('hideInfluenceurTips', 'true');
        setOpenModal(false);
    };


    return (
        <Page title="Affilation">
            {loading && <LinearProgress />}
            <Container sx={{ marginTop: { xs: 3 }, paddingBottom: 8 }}>
                <Stack
                    alignItems='start'
                    mb={3}
                    spacing={1}
                >
                    <CustomButton
                        type='secondaire'
                        buttonText='Retour'
                        startIcon={<Iconify icon="material-symbols:arrow-back-ios" />}
                        onClick={() => window.history.back()}
                    />
                    <Typography variant="h3" gutterBottom>
                        Affiliation <br />
                    </Typography>
                </Stack>

                <Stack spacing={3}>

                    <Box sx={{ border: '1px solid gainsboro', borderRadius: '7px' }} padding={2}>
                        <Typography variant='h4'>Informations sur le patenaire</Typography>
                        <Grid container sx={{ bgcolor: '#f2f2f2' }} padding={2}>
                            <Grid xs={12} sm={6}>
                                <Stack padding={1}>
                                    <Typography>Nom du partenaire</Typography>
                                    <TextField value={name} placeholder="Ex : Laura Dupont, Nom de l'organisation" onChange={(e) => handleName(e)} required type='text' error={nameError?.error} helperText={nameError?.msg} />
                                </Stack>
                            </Grid>
                            <Grid xs={12} sm={6}>
                                <Stack padding={1}>
                                    <Typography>Email du partenaire</Typography>
                                    <TextField disabled={!!affId} required value={email} placeholder="Ex : laura@email.com" onChange={(e) => handleEmail(e)} error={emailError?.error} helperText={emailError?.msg} />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ border: '1px solid gainsboro', borderRadius: '7px' }} padding={2}>
                        <Stack direction='row' justifyContent='space-between' alignItems='center'>
                            <Typography variant='h4'>Commission</Typography>
                            <Paper
                                elevation={0}
                                sx={{
                                    display: 'flex',
                                    width: 120,
                                    marginY: 1,
                                    border: (theme) => `1px solid #f2f2f2`,
                                    borderRadius: '7px',
                                    flexWrap: 'wrap',
                                    bgcolor: '#f2f2f2',
                                }}
                            >
                                <StyledToggleButtonGroup
                                    value={commission}
                                    exclusive
                                    onChange={handleCommission}
                                    aria-label="Platform"
                                    sx={{ color: 'red' }}
                                >
                                    <ToggleButton value={false}>Non</ToggleButton>
                                    <ToggleButton value>Oui</ToggleButton>
                                </StyledToggleButtonGroup>
                            </Paper>
                        </Stack>
                        {
                            commission &&
                            <Grid container sx={{ bgcolor: '#f2f2f2' }} padding={2}>
                                <Grid xs={12} >
                                    <Box sx={{ display: 'flex' }}>

                                        <Box onClick={() => setCommissionType(1)} sx={commissionType === 1 ? { bgcolor: '#F5EFFA', border: '1px solid #5E17EB', borderRadius: '10px', cursor: 'pointer' }
                                            :
                                            { bgcolor: 'gainsboro', borderRadius: '10px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                                            <Typography variant='body2'>Pourcentage</Typography>
                                        </Box>
                                        <Box padding={0.5} />
                                        <Box onClick={() => setCommissionType(0)} sx={commissionType === 0 ? { bgcolor: '#F5EFFA', border: '1px solid #5E17EB', borderRadius: '10px', cursor: 'pointer' }
                                            :
                                            { bgcolor: 'gainsboro', borderRadius: '10px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                                            <Typography variant='body2'>Montant fixe</Typography>
                                        </Box>

                                    </Box>
                                </Grid>
                                <Grid xs={12} sm={6}>
                                    <Stack padding={1} spacing={0.5}>
                                        <Typography variant='body1' >{commissionType === 0 ? 'Commission par vente (CFA)' : 'Commission par vente (%)'}</Typography>
                                        <NumberTextField value={commissionValue} onChange={handleCommissionValue} />
                                        <Box>
                                            <Typography variant='body2'>le partenaire aura une commission de <strong>{commissionValue} {commissionType === 0 ? 'CFA' : '%'}</strong> sur chaque achat</Typography>
                                        </Box>
                                    </Stack>
                                </Grid>
                            </Grid>
                        }

                    </Box>
                    <Box sx={codePromoError?.error ? { border: '1px solid red', borderRadius: '7px' } : { border: '1px solid gainsboro', borderRadius: '7px' }} padding={2}>
                        <Stack direction='row' justifyContent='space-between' alignItems='center'>
                            <Typography variant='h4'>Code promo</Typography>
                            <Paper
                                elevation={0}
                                sx={{
                                    display: 'flex',
                                    width: 120,
                                    marginY: 1,
                                    border: (theme) => `1px solid #f2f2f2`,
                                    borderRadius: '7px',
                                    flexWrap: 'wrap',
                                    bgcolor: '#f2f2f2',
                                }}
                            >
                                <StyledToggleButtonGroup
                                    value={codePromo}
                                    exclusive
                                    onChange={handlePromo}
                                    aria-label="Platform"
                                    sx={{ color: 'red' }}
                                >
                                    <ToggleButton value={false}>Non</ToggleButton>
                                    <ToggleButton value>Oui</ToggleButton>
                                </StyledToggleButtonGroup>
                            </Paper>
                        </Stack>
                        {
                            codePromo &&
                            <Box container sx={{ bgcolor: '#f2f2f2' }} padding={2}>
                                <Autocomplete
                                    options={discounts}
                                    getOptionLabel={(option) => option?.data()?.code}
                                    value={selectedDiscount}
                                    renderOption={(props, option) => (
                                        <Stack direction='row' spacing={1} component="li" {...props} display="flex" alignItems="center">
                                            <Iconify />
                                            <Box>
                                                <Typography variant="subtitle1">{option?.data()?.code}</Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    {option?.data().reduc.value}  {option?.data()?.reduc.type === 0 ? '%' : 'CFA'}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    )}
                                    renderInput={(params) => <TextField {...params} placeholder="Selectionner un code promo" variant="outlined" error={codePromoError?.error} />}
                                    onChange={(_event, value) => handleEventSelect(value)}
                                    filterOptions={(options, { inputValue }) =>
                                        options.filter((option) =>
                                            option?.data().code.toLowerCase().includes(inputValue.toLowerCase())
                                        )
                                    }
                                />
                            </Box>
                        }
                    </Box>

                </Stack>

            </Container>
            <Container>
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        padding: '16px',
                        // borderTop: '2px solid gainsboro',
                        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        display: 'flex',
                        justifyContent: 'right',
                        alignItems: 'center',
                    }}
                >
                    <CustomButton
                        type='secondaire'
                        buttonText='Annuler'
                        loading={loading}
                        onClick={() => window.history.back()}
                    />
                    <CustomButton
                        loading={loading}
                        type='primaire'
                        buttonText={affId ? 'Enregister' : 'Créer'}
                        onClick={affId ? updateAffiliation : createAffiliation}
                    />
                </Stack>
            </Container>
            <CustomModal open={openModal} title={"💡 Comment intéresser un influenceur ?"} cancelText='Ne plus afficher ce message' onClose={handleNeverShowAgain} confirmText='OK' onConfirm={handleClose}>
                <Stack spacing={1}>
                    <Typography variant="body2" paragraph>
                        En Côte d’Ivoire et plus largement en Afrique, les influenceurs sont souvent très actifs sur WhatsApp, TikTok, Instagram et Facebook.
                    </Typography>

                    <Typography variant="body2" paragraph>
                        Pour les motiver à promouvoir votre événement :
                    </Typography>

                    <ul style={{ paddingLeft: 16 }}>
                        <li>
                            <Typography variant="body2">
                                💰 <strong>Proposez une commission entre 10% et 20%</strong>. 15% est le taux idéal pour les motiver sans réduire trop votre marge.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2">
                                🎯 Ciblez les influenceurs qui ont une communauté proche de votre public (fans de musique, soirées, humour...).
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2">
                                🧰 Fournissez-leur le lien de suivi générer par choptonticket et des visuels prêts à partager : ça les aide à communiquer efficacement.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2">
                                📊 Montrez-leur leurs gains potentiels : par exemple “Tu gagnes 2000 FCFA pour chaque billet vendu à 10 000 FCFA”.
                            </Typography>
                        </li>
                    </ul>

                    <Typography variant="body2">
                        👉 Une collaboration bien pensée peut considérablement booster vos ventes !
                    </Typography>
                </Stack>
            </CustomModal>
            <CustomSnack open={openSnack} handleClose={handleCloseSnack} msg={msg} />

        </Page>
    );
}
